import * as CryptoJS from 'crypto-js';
const secretKey='1234567891113456';

export class EncryptionUtil {
  static encryptData(plainText: string): string {
    const iv = CryptoJS.lib.WordArray.random(16);

    const encrypted = CryptoJS.AES.encrypt(
      plainText,
      CryptoJS.enc.Utf8.parse(secretKey),
      {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      }
    );

    const encryptedDataWithIV = iv.concat(encrypted.ciphertext);
    return CryptoJS.enc.Base64.stringify(encryptedDataWithIV);
  }

  static decryptData(encryptedBase64: string): string {
    const encryptedData = CryptoJS.enc.Base64.parse(encryptedBase64);
    const iv = CryptoJS.lib.WordArray.create(encryptedData.words.slice(0, 4));
    const ciphertext = CryptoJS.lib.WordArray.create(encryptedData.words.slice(4));

    const decrypted = CryptoJS.AES.decrypt(
      { ciphertext } as any,
      CryptoJS.enc.Utf8.parse(secretKey),
      {
        iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      }
    );

    return decrypted.toString(CryptoJS.enc.Utf8);
  }
}
